import {useTranslation} from '@/translations/i18n'
import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {EditDetailsSectionButtons} from '@/components/commons/edit-details-section-buttons/EditDetailsSectionButtons'
import {Text} from '@/components/ui/text/Text'
import {HttpGetProjectNotesResponse} from '@/features/projects/http/projects.http'
import {NotesFormProvider} from '@/features/projects/components/notes-form-provider/NotesFormProvider'
import {OperationalNotesForm} from '@/features/projects/components/operational-notes-form/OperationalNotesForm'
import {CardInEditModeType} from '@/pages/project-details-notes/ProjectDetailsNotes'
import {useMemo} from 'react'
import {ProjectNotesType} from '../../types'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

interface OperationalNotesSectionProps {
    operationalNotes?: HttpGetProjectNotesResponse
    cardInEditMode: CardInEditModeType
    setCardInEditMode: (cardInEditMode: CardInEditModeType | null) => void
    isLoading: boolean
}
export const OperationalNotesSection = ({
    operationalNotes,
    cardInEditMode,
    setCardInEditMode,
    isLoading
}: OperationalNotesSectionProps) => {
    const {t} = useTranslation()
    const isActive = cardInEditMode === 'OperationalNotesSection'

    const handleCancel = () => {
        setCardInEditMode(null)
    }

    const handleEdit = () => {
        setCardInEditMode('OperationalNotesSection')
    }

    const defaultValues = useMemo(() => {
        return {
            notesDescription: operationalNotes?.note,
            notesType: ProjectNotesType.enum.operational_notes
        }
    }, [operationalNotes])

    if (isActive) {
        return (
            <NotesFormProvider defaultValues={defaultValues}>
                <OperationalNotesForm setCardInEditMode={setCardInEditMode} />
            </NotesFormProvider>
        )
    }

    return (
        <DetailsFieldsSection
            variant="neutral"
            isDisabled={cardInEditMode === 'AdministrativeActivitiesSection'}
            title={t('projects:operational_notes')}
            headingEndSlot={
                <EditDetailsSectionButtons
                    isDisabled={isLoading}
                    isActive={isActive}
                    onCancel={handleCancel}
                    onEdit={handleEdit}
                />
            }
        >
            {isLoading ? (
                <Skeleton height={20} width={'50%'} />
            ) : operationalNotes?.note ? (
                <Text>{operationalNotes?.note}</Text>
            ) : (
                <Text palette="neutral" shade="400" size="textSm" weight="500">
                    {t('commons:none_female')}
                </Text>
            )}
        </DetailsFieldsSection>
    )
}
